<style type="text/css">
    @import '../../assets/i5gam/css/i5gam.css';
</style>

<style type="text/css">
    #pageMask {
        position: fixed;
        top:0;
        left: 0;
        width: 100%;
        height: 100%;
        text-align:center;
        line-height:50;
        z-index: 10000;
    }

    #pageMask .loading-img{
        position:absolute;
        top:50%;
        left:50%;
        width:250px;
        height:150px;
        margin:-125px 0 0 -75px;
        z-index: 10001;
    }

    #pageMask .loading-backgroud{
        opacity:0.8;
        background-color:#fff;
        width: 100%;
        height: 100%;
    }

</style>

<template>
    <div>
        <iframe name='hddnFrame' id='hddnFrame' style="display: none;"></iframe>
        <div id="pageMask" v-if="pageMaskShowAt">
            <img class="loading-img" src="../../assets/i5gam/images/loading.gif"/>
            <div class="loading-backgroud"></div>
        </div>
        <popup v-show="popupShowAt"></popup>
        <div id="content-area"
             style="width: 100%;height: 100%;overflow-y: auto">
            <template v-if="showAt">
                <template v-if="viewType == 'index'||viewType == 'sub'">
                    <div id="wrapper">
                        <div id="wrap"
                             :class="viewType == 'index'?'i5gam-wrap':''">
                            <a href="javascript:;"
                               v-if="viewType == 'index'"
                               @click="btn_csClick()"
                               style="position:fixed;bottom:100px;right:50px;display:block;width:140px;height:140px;z-index:9;">
                                <img v-if="mberInfo.jkUseAt == 'Y'" src="../../assets/i5gam/images/icon-customer-i5gam.jkUse.png"/>
                                <img v-else src="../../assets/i5gam/images/icon-customer-i5gam.png"/>
                            </a>
                            <div class="jb-grid--top">
                                <a href="javascript:;"
                                   v-if="viewType == 'index'"
                                   @click="btn_downLoadClick('cntrct')"
                                   style="display:block;height:50px;line-height:48px;background:#70809f;text-align:center;z-index:9;">
                                    <img src="../../assets/i5gam/images/download-i5gam.png"/>
                                </a>
                                <nav class="gnb-wrap">
                                    <div class="gnb">
                                        <a href="javascript:;">
                                            <h1>
                                                <img src="../../assets/i5gam/images/img-h1-main-logo.png"
                                                     alt="걸음마 아이오감"
                                                     @click="btn_mainClick()"/>
                                            </h1>
                                        </a>
                                        <!--
                                        <a href="javascript:;"
                                           :class="'current'">자료실</a>
                                        -->
                                        <a href="javascript:;"
                                           v-for="(info,index) in menuList"
                                           :key="'menu'+index"
                                           :class="routeName == info.routeName?'current':''"
                                           @click="info.clickFunc()">{{info.name}}</a>
                                    </div>
                                    <div class="main-top-util">
                                        <template v-if="viewType != 'index'">
                                            <a href="javascript:;"
                                               class="txt"
                                               v-if="!loginAt"
                                               @click="btn_loginClick()">로그인</a>
                                            <a href="javascript:;"
                                               class="txt"
                                               v-if="!loginAt"
                                               @click="btn_joinClick()">회원가입</a>
                                            <a href="javascript:;"
                                               class="txt"
                                               v-if="loginAt"
                                               @click="btn_mypageClick()">마이페이지</a>
                                            <a href="javascript:;"
                                               class="txt"
                                               v-if="loginAt"
                                               @click="btn_logoutClick()">로그아웃</a>
                                        </template>
                                    </div>
                                </nav>
                            </div>
                            <router-view v-if="showAt"></router-view>
                            <footer id="footer">
                                <div class="grid--con-sub">
                                    <div class="footer-link">
                                        <span><a href="javascript:;"
                                                 @click="openTermsPopup('tos')" style="color:black;font-size: 20px;">이용약관</a></span>
                                        <span><a href="javascript:;"
                                                 @click="openTermsPopup('pp')" style="color:black;font-size: 20px;">개인정보처리방침</a></span>
                                        <span style="font-size: 20px;" v-if="mberInfo.jkUseAt == 'Y'">고객지원 1899-8255</span>
                                        <span style="font-size: 20px;" v-else>고객지원 1661-5029</span>
                                    </div>
                                    <address>
                                        <!-- <span>(주)에이티엔</span>사업자등록번호:126-86-03002   주소: 경기도 이천시 마장면 덕평로 771-10(사무동)<br />
                                        <span>걸음마넷 (주)온앤온정보시스템</span>사업자등록번호:120-81-84415  주소: 서울시 강동구 천호대로1095, 3층(천호동, 현대코아) -->
                                        <span>(주)가치브라더</span>사업자등록번호:119-86-81107   서울시 구로구 디지털로 31길 19, 404호(구로동, 에이스테크노타워 2차)
                                    </address>
                                </div>
                            </footer>
                        </div>
                        <div class="i5gam-mobile" v-if="viewType == 'index'">
                            <a href="javascript:;" @click="btn_downLoadClick('cntrct')"><img src="../../assets/i5gam/images/i5gam-mobile-download.png"/></a>
                            <img src="../../assets/i5gam/images/i5gam-mobile1.png" />
                            <a href="javascript:;" @click="showVideoMenual('https://youtu.be/OlGBx5DIo_c')"><img src="../../assets/i5gam/images/i5gam-mobile2.png" /></a>
                            <a href="javascript:;" @click="showVideoMenual('https://youtu.be/bcC3bjL-0MY')"><img src="../../assets/i5gam/images/i5gam-mobile3.png" /></a>
                            <a href="javascript:;" @click="showVideoMenual('https://youtu.be/iKorYm7YYUk')"><img src="../../assets/i5gam/images/i5gam-mobile4.png" /></a>
                            <a href="javascript:;" @click="showVideoMenual('https://youtu.be/dAlQtqBvtnE')"><img src="../../assets/i5gam/images/i5gam-mobile6.png" /></a>
                            <img src="../../assets/i5gam/images/i5gam-mobile5.png" />
                            <a href="javascript:;" @click="btn_downLoadClick('cntrct')"><img src="../../assets/i5gam/images/i5gam-mobile-download.png"/></a>
                        </div>
                    </div>
                </template>
                <template v-if="viewType == 'etc'">
                    <router-view v-if="showAt"></router-view>
                </template>
            </template>
        </div>
    </div>
</template>

<script>

    import popup from './components/common/popup/layout.vue'

    export default {
        name: 'app',
        components: {
            'popup':popup,
        },
        data: function(){
            return {
                showAt: false,
                menuList: [
                    {name:'회사소개',routeName:'views.i5gam.explan.company',clickFunc:this.btn_companyClick},
                    {name:'아이오감 특장점',routeName:'views.i5gam.explan.goodsAdvntg',clickFunc:this.btn_goodsAdvntgClick},
                    {name:'신청ㆍ설치안내',routeName:'views.i5gam.explan.reqInstall',clickFunc:this.btn_reqInstallClick},
                    {name:'자료실',routeName:'views.i5gam.cs.cloud',clickFunc:this.btn_cloudClick},
                    {name:'고객지원',routeName:'views.i5gam.cs.cs',clickFunc:this.btn_csClick}
                ]
            }
        },
        computed: {
            popupInfo:function(){
                return this.$store.getters.getPopupInfo;
            },
            popupShowAt: function(){
                return this.popupInfo.showAt;
            },
            pageMaskShowAt:function(){
                return this.$store.getters.getPageMaskShowAt;
            },
            mberInfo : function(){
                return this.$store.getters.getMberInfo;
            },
            loginAt : function(){
                return this.$store.getters.getLoginAt;
            },
            routeInfo:function(){
                return this.$store.getters.getRouteInfo;
            },
            viewType:function(){
                return this.routeInfo.viewType;
            },
            routeName:function(){
                return this.routeInfo.name;
            }
        },
        methods:{
            init:function(){
                window.addEventListener('resize', this.handleResize);
                this.handleResize();

                window.addEventListener('scroll', this.handleScroll);
                this.handleScroll();

                this.$store.commit('setPageMaskShowAt',true);

                this.$router.push({ name: 'views.i5gam.index'});

                this.showAt = true;
                this.$store.commit('setPageMaskShowAt',false);
            },
            handleResize: function() {
                this.$store.commit('setWindowWidthHeight',{width:window.innerWidth,height:window.innerHeight});
            },
            handleScroll: function() {
                this.$store.commit('setWindowScrollY',window.scrollY);
            },
            btn_companyClick : function(){
                this.$router.push({ name: 'views.i5gam.explan.company'});
            },
            btn_goodsAdvntgClick : function(){
                this.$router.push({ name: 'views.i5gam.explan.goodsAdvntg'});
            },
            btn_reqInstallClick : function(){
                this.$router.push({ name: 'views.i5gam.explan.reqInstall'});
            },
            btn_cloudClick : function(){
                this.$router.push({ name: 'views.i5gam.cs.cloud'});
            },
            btn_csClick : function(){
                this.$router.push({ name: 'views.i5gam.cs.cs'});
            },
            btn_loginClick: function(){
                this.$router.push({ name: 'views.i5gam.index'});
            },
            btn_joinClick: function(){
                this.$router.push({ name: 'views.i5gam.member.join'});
            },
            btn_mypageClick : function(){
                this.$router.push({ name: 'views.i5gam.member.myPage'});
            },
            btn_logoutClick : function(){
                this.$store.dispatch('logoutProc');
                this.$router.push({ name: 'views.i5gam.index'});
            },
            btn_downLoadClick : function(downloadSe){
                const _this = this;
                let fileNm = '';
                let orgNm = '';
                let downUrl = '';

                if(downloadSe=='cntrct'){   //계약서
                    fileNm = '202009292590231_0.pdf';
                    orgNm = '걸음마 아이오감 서비스 표준 계약서.pdf';
                    downUrl = '/fileApi/down/dst/A1517F38C58AA8907C64522034B454647405626374A476D541F05FE4062A53657873366AA84A70086FD5E475BB0966C83CA8364E4EABC60CD15A6545E6566386804A834B33';
                }else if(downloadSe == 'manual'){   //매뉴얼
                    fileNm = '20200203112913999.pptx';
                    orgNm = '아이오감매뉴얼_통합_사용자_매뉴얼_v0.95_음성수정.pptx';
                    downUrl = '/fileApi/down/dst/AC7EB738357DE87A5B05B44B508DB86547C7B7958658C61553094A636634471F983EA35BB645F446C444426676F566A1364A0712783B556D28C7D56373383164A54535';
                }else if(downloadSe == 'ot'){	//ot자료
                    fileNm = '20200219183013999.pptx';
                    orgNm = '『걸음마 아이오감』 알림장 _부모OT자료.pptx';
                    downUrl = '/fileApi/down/dst/2CF785475456D3641CB55687518D734E58DB31D556626F46545A1F0CB3A338B38F572494B6A95668ABCA88C661744B46073585B47674676543502A4E37395353696F43';
                }

                let fileInfo = {fileNm:fileNm, orgNm:orgNm, downUrl:downUrl};

                _this.$onbiLib.getAuthKey().then(function(authKey){
                    _this.$onbiLib.setCdnFileDownLoadUrl(fileInfo,encodeURIComponent(authKey));
                });
            },
            btn_mainClick : function(){
                this.$router.push({ name: 'views.i5gam.index'});
            },
            openTermsPopup : function(tabSe){
                const popupInfo = {
                    se:'modal',
                    id:'termsPopup',
                    wid:'1180',
                    hei:'',
                    tit:'이용약관 동의',
                    draggableAt:true,
                    param : {
                        tabSe : tabSe
                    }
                };

                this.$store.commit('openPopup',popupInfo);
            },
            showVideoMenual: function(url){
				window.open(url);
			},
        },
        mounted:function(){
            const _this = this;

            this.$store.dispatch('searchDayInfo').then(function(){
                _this.init();
            }).catch(function(e){
                console.log(e);
                _this.$toasted.show(_this.$onbiLib.msg.err.system);
            });
        }
    }
</script>

<style scoped>

</style>